import { createSelector } from '@ngrx/store';

import { loylatyProductProgramsState } from '../root';

export const isDownloadingAnyProgram = createSelector(loylatyProductProgramsState, (loyaltyProductPrograms) => loyaltyProductPrograms.isDownloading === true);
